<template>
  <div class="flex items-center justify-end flex-nowrap gap-8">
    <OButton
      size="sm"
      secondary
      icon="view_column_2"
      :class="{ active: visualizacao === 'column' }"
      @click="emit('click:view', 'column')"
    />
    <OButton
      size="sm"
      secondary
      icon="splitscreen"
      :class="{ active: visualizacao === 'row' }"
      @click="emit('click:view', 'row')"
    />
  </div>
</template>

<script setup>
import OButton from 'components/Button/OButton.vue'
import usePerguntas from 'composables/usePerguntas'

const { visualizacao } = usePerguntas()

const emit = defineEmits(['click:view'])
</script>

<style lang="scss"></style>
